import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEO = ({ title, description, keywords, ogTitle, ogDescription, ogImage, ogUrl }) => {
  const location = useLocation();

  useEffect(() => {
    // Update Title
    if (title) {
      document.title = title;
    }

    // Update Meta Description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description || "Newsmedia Association of India (NAI) - India's Premier Multi-Media Journalists & Professionals Protection Forum.");
    } else {
      metaDescription = document.createElement('meta');
      metaDescription.name = "description";
      metaDescription.content = description || "Newsmedia Association of India (NAI) - India's Premier Multi-Media Journalists & Professionals Protection Forum.";
      document.head.appendChild(metaDescription);
    }

    // Update Keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', keywords || "NAI, Newsmedia Association of India, Journalist protection, Media rights, Press freedom India, Multi-media journalism");
    } else {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = "keywords";
      metaKeywords.content = keywords || "NAI, Newsmedia Association of India, Journalist protection, Media rights, Press freedom India, Multi-media journalism";
      document.head.appendChild(metaKeywords);
    }

    // Update OG tags
    const updateOgTag = (property, content) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (tag) {
        tag.setAttribute('content', content);
      } else {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        tag.setAttribute('content', content);
        document.head.appendChild(tag);
      }
    };

    updateOgTag('og:title', ogTitle || title || "Newsmedia Association of India");
    updateOgTag('og:description', ogDescription || description || "India's Premier Multi-Media Journalists & Professionals Protection Forum.");
    updateOgTag('og:type', 'website');
    updateOgTag('og:url', ogUrl || window.location.href);
    if (ogImage) {
        updateOgTag('og:image', ogImage);
    }

    // Update Twitter tags
    const updateTwitterTag = (name, content) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (tag) {
        tag.setAttribute('content', content);
      } else {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        tag.setAttribute('content', content);
        document.head.appendChild(tag);
      }
    };

    updateTwitterTag('twitter:card', 'summary_large_image');
    updateTwitterTag('twitter:title', ogTitle || title || "Newsmedia Association of India");
    updateTwitterTag('twitter:description', ogDescription || description || "India's Premier Multi-Media Journalists & Professionals Protection Forum.");
    if (ogImage) {
        updateTwitterTag('twitter:image', ogImage);
    }

  }, [title, description, keywords, ogTitle, ogDescription, ogImage, ogUrl, location]);

  return null;
};

export default SEO;
